module.exports = __webpack_public_path__ + "img/weddings_16_H.f679c2cf.webp";